import type { VoxelMap } from '@/voxelTypes'

export type NeighborFlags = {
  xp: boolean
  xm: boolean
  yp: boolean
  ym: boolean
  zp: boolean
  zm: boolean
}

export interface VoxelPackingContext {
  key: number
  voxel: any
  voxelMap: VoxelMap
  position: { x: number; y: number; z: number }
  neighbors: NeighborFlags
  maskBits: number
  storage: Uint32Array
  storageIndex: number
  packedColorLinear: number
  srgbColor: number
}

export interface VoxelPackingDescriptor {
  needsLegacy?: boolean
  customize?(context: VoxelPackingContext): void
}

import { getVoxelSpec } from './registry'

const DEFAULT_DESCRIPTOR: VoxelPackingDescriptor = Object.freeze({
  needsLegacy: true,
})

export function getVoxelPacking(type: string): VoxelPackingDescriptor {
  return getVoxelSpec(type)?.packing ?? DEFAULT_DESCRIPTOR
}

export function usesLegacyVoxelPipeline(type: string): boolean {
  const descriptor = getVoxelPacking(type)
  return descriptor.needsLegacy ?? false
}

export function usesModernVoxelPipeline(type: string): boolean {
  return !usesLegacyVoxelPipeline(type)
}
